import type {FeGridSettings} from '../types/Api';

const DEFAULT_ITEMS_PER_PAGE = 50;

export const DEFAULT_SETTINGS: FeGridSettings = {
  valueWrapMode: 'TRUNCATE',
  activeFilterBarVisible: true,
  confirmSortReplacement: true,
  horizontalSeparatorsVisible: true,
  itemsPerPage: DEFAULT_ITEMS_PER_PAGE,
  keyboardNavigationEnabled: false,
  columnGroupsVisible: false,
  stripedRows: false,
  summaryRowVisible: false,
  verticalSeparatorsVisible: false,
  headerHeight: 'DEFAULT',
  // 'TALL' is the "comfortable" density (the Settings panel still offers the full
  // range); the toolbar compact/comfortable quick toggle was removed.
  rowHeight: 'TALL',
};
